import { render, staticRenderFns } from "./WidgetOptions.vue?vue&type=template&id=349889fd&"
import script from "./WidgetOptions.vue?vue&type=script&lang=js&"
export * from "./WidgetOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports